import { render, staticRenderFns } from "./ShippedGoods.vue?vue&type=template&id=1828587b&scoped=true"
import script from "./ShippedGoods.vue?vue&type=script&lang=js"
export * from "./ShippedGoods.vue?vue&type=script&lang=js"
import style0 from "./ShippedGoods.vue?vue&type=style&index=0&id=1828587b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828587b",
  null
  
)

export default component.exports